/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { QBRManagedTable } from './QBRManagedTable';
import { QBRPieChart } from './QBRPieChart';
import { QBRReportHeader } from './QBRReportHeader';
import { QBRScoreHistoryAndInsights } from './QBRScoreHistoryAndInsights';

export const QBRFirstManagedAppScore = (props) => {
    const { t } = useTranslation();
    const { reportData, renderingScheduledReport } = props;

    const reportType = 'ManagedAppScore';

    const stages = Object.entries(reportData.data).map(([key, value]) => ({
        name: t(`Common.${key}`),
        value
    }));

    return (
        <>
            <QBRReportHeader {...{ ...props, reportType }} />
            <QBRScoreHistoryAndInsights
                reportType={reportType}
                props={{ ...props }}
            />
            <QBRPieChart
                data={stages}
                renderingScheduledReport={renderingScheduledReport}
                title={t('QBR.applicationManagementStatus')}
            />
            <hr />
            <QBRManagedTable
                rows={reportData.topUnmanaged}
                rowsPerPage={-1}
                title={t('QBR.top10UnManagedApplicationsByUsage')}
            />
        </>
    );
};
